import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Typography, Grid, Radio, RadioGroup, FormControlLabel, FormControl, FormHelperText, Button, useMediaQuery, Stack, Dialog, DialogTitle, DialogContent, DialogActions, debounce } from "@mui/material";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextArea from "../commoncomponents/CustomTextArea";
import AddIcon from '@mui/icons-material/Add';
import ComponentHeader from "../commoncomponents/ComponentHeader";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDateTimePicker from "../commoncomponents/CustomDateTimePicker";
import { useDispatch, useSelector } from "react-redux";
import { addRepairTrackerDetails, assessmentsDetails, clearRepairtracker, deleteRepairTracker, updateAssessmentsPartsInitialState, updateAssessmentsPartsRequired, updateOutsourceDetails, updateRepairTrackerDetails, updateWorkOrderStatus } from "../../redux/actions/ScmActionTypes";
import dayjs from "dayjs";
import ScmBottomButtonsforWorkOrder from "./ScmBottomButtonsforWorkOrder";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
import { v4 as uuidv4 } from 'uuid';
import CustomDialog from "../commoncomponents/CustomDialog";
import ScmRepositry from "../../api/repositories/scmRepository";
import CustomTimePicker from "../commoncomponents/CustomTimePicker";
import { mandatoryFields } from "../../redux/actions/assetActions";
import PageLoader from "../commoncomponents/PageLoader";
import { getcompanyId } from "../../utility/tokenUtility";
import { processingPercentageValue, statusList } from "../../utility/message";

const AddRowDialogue = ({ open, onClose, editMode, rows, setRows,vendorName }) => {
    const dispatch = useDispatch();
    const basicDetails = useSelector((state) => state.workOrderBasicDetails);
    const setOutsourceDetails = basicDetails?.vendorField;

    const initialState = {
        employeename: '',
        flag: {},
        pic: {},
        activity: {},
        startDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
        endDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
        repairDuration: "0 Mins",
        remarks: "",
        technician: ""
    };

    const [itemData, setItemData] = useState(initialState || {});
    const [option, setOption] = useState({
        employeename: [],
        flag: [],
        pic: [],
        activity: [],
    });

    const [error, setError] = useState({
        startDateandTime: false,
        endDateandTime: false,
        employeename: false
    });

    const [errorMessage, setErrorMessage] = useState({
        startDateandTime: '',
        endDateandTime: '',
        employeename: ''
    });

    const handleGridDataChange = (value, name) => {
        const values = name === "repairDuration" || name === "preparationHours" || name === "verificationHours"
            ? value?.slice(0, 2) + value?.slice(2) : value;

        setItemData((previous) => {
            const updatedData = {
                ...previous,
                [name]: values || ""
            };


            if (name === "employeename") {
                updatedData.employeename = { ...value, label: value?.employeename ? value?.employeename : '' };
            };

            if (name === "startDateandTime" || name === "endDateandTime") {
                const start = new Date(updatedData.startDateandTime);
                const end = new Date(updatedData.endDateandTime);
                if (start && end && end >= start) {
                  const durationInMs = end - start;
                  const totalMinutes = Math.floor(durationInMs / (1000 * 60)); // Convert duration to total minutes
                  updatedData.repairDuration = `${totalMinutes} Mins`;
                } else {
                  updatedData.repairDuration = "0 Mins";
                }
              }

            return updatedData;
        });


        setError((prev) => {
            const updatedError = {
                ...prev,
                [name]: false
            };
            return updatedError;
        });

        setErrorMessage((prev) => ({
            ...prev,
            [name]: ''
        }));


        const workOrderDateAndTime = new Date(basicDetails?.workorderDateandTime);
        const selectedDate = new Date(value);
        const currentDate = new Date();
        const endDate = new Date(itemData?.endDateandTime);

        if (name === 'startDateandTime' && value) {

            if (selectedDate < workOrderDateAndTime || selectedDate > currentDate) {
                setError((prevErrors) => ({
                    ...prevErrors,
                    startDateandTime: true,
                }));
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    startDateandTime: "Start date and time should be between Work Order date and current date/time.",
                }));
            } else {
                setError((prevErrors) => ({
                    ...prevErrors,
                    startDateandTime: false,
                }));
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    startDateandTime: "",
                }));
            }

            if (endDate && selectedDate) {
                if (selectedDate >= endDate) {
                    setError((prevErrors) => ({
                        ...prevErrors,
                        endDateandTime: true,
                    }));
                    setErrorMessage((prevErrorMessages) => ({
                        ...prevErrorMessages,
                        endDateandTime: "End date and time should be greater than the Start date and time.",
                    }));
                } else {
                    setError((prevErrors) => ({
                        ...prevErrors,
                        endDateandTime: false,
                    }));
                    setErrorMessage((prevErrorMessages) => ({
                        ...prevErrorMessages,
                        endDateandTime: "",
                    }));
                }
            };
        };

        if (name === 'endDateandTime' && value) {
            const selectedEndDateTime = new Date(value);
            const startDateTime = new Date(itemData?.startDateandTime);
            if ( selectedEndDateTime < startDateTime ) {
                setError((prevErrors) => ({
                    ...prevErrors,
                    endDateandTime: true,
                }));
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    endDateandTime: "End date and time should be greater than the Start date and time.",
                }));
            } else {
                setError((prevErrors) => ({
                    ...prevErrors,
                    endDateandTime: false,
                }));
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    endDateandTime: "",
                }));
            };
        };
    };



    const fetchOption = async () => {
        const employeeName = await ScmRepositry.fetchEmployeeDetails();
        setOption((previous) => ({
            ...previous,
            employeename: employeeName?.map((item, index) => ({
                key: `option${index}`,
                label: `${item?.employeecode || ""} - ${item?.employeename || ""}` || "",
                employeename: item?.employeename || "",
                employeecode: item?.employeecode || "",
                designation: item?.designation || "",
                empservice: item?.empservice || "",
                id: item?.id || ""
            }))
        }));

        const lovOptions = await ScmRepositry.lovOptions();
        setOption((previous) => ({
            ...previous,
            flag: lovOptions?.femuschworepairflags?.map((item, index) => ({
                key: `option${index}`,
                label: item?.repairflag,
                id: item?.id
            }))
        }));

        setOption((previous) => ({
            ...previous,
            pic: lovOptions?.femuschworepairpics?.map((item, index) => ({
                key: `option${index}`,
                label: item?.repairpic,
                id: item?.id
            }))
        }));

        setOption((previous) => ({
            ...previous,
            activity: lovOptions?.femuschworepairactivities?.map((item, index) => ({
                key: `option${index}`,
                label: item?.repairactivity,
                id: item?.id
            }))
        }));
    };

    useEffect(() => {
        fetchOption();
    }, []);


    const handleCancel = () => {
        setItemData(initialState);
        onClose();
        setErrorMessage({});
        setError({});
    };


    const handleSave = async (e) => {
        e.preventDefault();
        if (!error.startDateandTime && !error.endDateandTime) {

            if (editMode?.dummy_id || editMode?.id) {
                if (editMode?.id) {
                    // Update existing row
                    const updatedRows = rows.map((row) =>
                        row.id === editMode?.id ? itemData : row
                    );
                    setRows(updatedRows);
                } else if (editMode?.dummy_id) {
                    // Update existing row
                    const updatedRows = rows.map((row) =>
                        row?.dummy_id === editMode?.dummy_id ? itemData : row
                    );
                    setRows(updatedRows);
                };

                dispatch(updateRepairTrackerDetails("UPDATE_REPAIR_TRACKER_DETAILS", { ...itemData }));
            } else {
                // Add new row
                const newItem = {
                    ...itemData,
                    dummy_id: uuidv4(),
                };
                dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", { ...newItem }))
                setItemData(initialState);
            }
            onClose();
        };
    };

    useEffect(() => {
        if (editMode?.dummy_id || editMode?.id) {
            if (editMode?.dummy_id) {
                setItemData({
                    dummy_id: editMode?.dummy_id || "",
                    activity: {
                        key: editMode.activity?.key || "",
                        label: `${editMode.activity?.label || ""}` || "",
                        id: editMode.activity?.id || "",
                    },
                    employeename: {
                        key: editMode.employeename?.key || "",
                        label: `${editMode.employeename?.employeename || ""}`,
                        id: editMode.employeename?.id || "",
                        designation: editMode.employeename?.designation || "",
                        employeename: editMode?.employeename?.employeename || "",
                        employeecode: editMode?.employeename?.employeecode || ""
                    },
                    flag: {
                        key: editMode.flag?.key || "",
                        label: `${editMode.flag?.label || ""}` || "",
                        id: editMode.flag?.id || "",
                    },
                    pic: {
                        key: editMode.pic?.key || "",
                        label: `${editMode.pic?.label || ""}` || "",
                        id: editMode.pic?.id || "",
                    },
                    preparationHours: editMode?.preparationHours || "",
                    remarks: editMode?.remarks || "",
                    repairDuration: editMode?.repairDuration || "",
                    startDateandTime: editMode?.startDateandTime || "",
                    endDateandTime: editMode?.endDateandTime || "",
                    verificationHours: editMode?.verificationHours || "",
                    technician: editMode?.technician || "",
                    id: editMode?.id || "",
                });
            } else if (editMode?.id) {
                setItemData({
                    dummy_id: editMode?.dummy_id || "",
                    activity: {
                        key: editMode.activity?.key || "",
                        label: `${editMode.activity?.label || ""}` || "",
                        id: editMode.activity?.id || "",
                    },
                    employeename: {
                        key: editMode.employeename?.key || "",
                        label: `${editMode.employeename?.employeename || ""}`,
                        id: editMode.employeename?.id || "",
                        designation: editMode.employeename?.designation || "",
                        employeename: editMode?.employeename?.employeename || "",
                        employeecode: editMode?.employeename?.employeecode || ""
                    },
                    flag: {
                        key: editMode.flag?.key || "",
                        label: `${editMode.flag?.label || ""}` || "",
                        id: editMode.flag?.id || "",
                    },
                    pic: {
                        key: editMode.pic?.key || "",
                        label: `${editMode.pic?.label || ""}` || "",
                        id: editMode.pic?.id || "",
                    },
                    preparationHours: editMode?.preparationHours || "",
                    remarks: editMode?.remarks || "",
                    repairDuration: editMode?.repairDuration || "",
                    startDateandTime: editMode?.startDateandTime || "",
                    endDateandTime: editMode?.endDateandTime || "",
                    verificationHours: editMode?.verificationHours || "",
                    technician: editMode?.technician || "",
                    id: editMode?.id || "",
                    timeStamp: editMode?.timeStamp || "",
                });
            }

        } else {
            setItemData(initialState);
        }
    }, [editMode]);

    const isAddDisabled =
        !(itemData?.employeename?.label || itemData?.technician) ||
        !itemData.startDateandTime ||
        !itemData.endDateandTime ||
        error.startDateandTime ||
        error.endDateandTime ||
        itemData.startDateandTime === "" ||
        itemData.endDateandTime === "";

    return (
        <Dialog
            open={open}
        >
            <DialogTitle>
                <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>{editMode ? "Edit Repair Tracker" : "Add Repair Tracker"}</Typography>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                {!setOutsourceDetails && <Grid item xs={6} md={6}>
                    <CustomTextFieldWithSearch
                    autoFocus={true}
                    label="Employee Name"
                    id="employeename"
                    name="employeename"
                    value={itemData?.employeename}
                    onChange={handleGridDataChange}
                    options={option?.employeename || []}
                    error={error?.employeename}
                    errorMessage={errorMessage?.employeename || ""}
                    isMandatoryField={true}
                    />
                </Grid>}
                {setOutsourceDetails &&
                    <>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                        label={"Vendor"}
                        id={"vendor"}
                        name={"vendor"}
                        value={vendorName || ""}
                        onChange={handleGridDataChange}
                        disabled={true}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                        label={"Vendor Technician"}
                        id={"technician"}
                        name={"technician"}
                        value={itemData?.technician}
                        onChange={handleGridDataChange}
                        isMandatoryField={true}
                        />
                    </Grid>
                    </>
                }
                    <Grid item xs={6} md={6}>
                        <CustomSelectInput
                            label="Flag"
                            id="flag"
                            name="flag"
                            options={option?.flag || []}
                            value={itemData?.flag || ""}
                            onChange={handleGridDataChange}
                            modal={true}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomSelectInput
                            label={"Unit"}
                            name="pic"
                            value={itemData?.pic || ""}
                            onChange={handleGridDataChange}
                            options={option?.pic || []}
                            modal={true}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomSelectInput
                            label="Activity"
                            id="activity"
                            name="activity"
                            onChange={handleGridDataChange}
                            value={itemData?.activity || ""}
                            options={option?.activity || []}
                            modal={true}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomDateTimePicker
                            label="Start Date and Time"
                            onDateChange={(e) => handleGridDataChange(e, "startDateandTime")}
                            value={itemData?.startDateandTime || ""}
                            modal={true}
                            disableFutureDate={false}
                            error={error?.startDateandTime}
                            helperText={errorMessage?.startDateandTime}
                            isMandatoryField={true}
                            displayDefaultValue={false}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomDateTimePicker
                            label="End Date and Time"
                            onDateChange={(e) => handleGridDataChange(e, "endDateandTime")}
                            value={itemData?.endDateandTime || ""}
                            shouldValidateFutureTime={true}
                            modal={true}
                            disableFutureDate={false}
                            error={error?.endDateandTime}
                            helperText={errorMessage?.endDateandTime}
                            isMandatoryField={true}
                            displayDefaultValue={false}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                            label={"Repair Duration"}
                            id={"repairDuration"}
                            name={"repairDuration"}
                            value={itemData?.repairDuration}
                            onChange={handleGridDataChange}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                            label={"Remarks"}
                            id={"remarks"}
                            name={"remarks"}
                            value={itemData?.remarks}
                            onChange={handleGridDataChange}
                            maxlength={255}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleSave} disabled={isAddDisabled}>
                    {editMode ? "UPDATE" : "ADD"}
                </Button>
                <Button variant="outlined" onClick={handleCancel}>
                    CANCEL
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const ScmAssessments = ({ setPage, page, buttonAttributes }) => {

    //prop value that holds all details about current page,buttons,header,etc., refer AssetMain.jsx for more info
    const findHeaderContent = buttonAttributes.find(
        (item) => item.currentPageName === page
    );

    function AddRowButton({ onClick }) {
        return (
            <Box sx={{ mt: 2 }}>
                <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={onClick}>
                    Add Row
                </Button>
            </Box>
        );
    };

    const location = useLocation();
    const dispatch = useDispatch();
    const basicDetails = useSelector((state) => state.scmBasicDetails);
    const assessmentsMandatoryFields = useSelector((state) => state.scmMandatoryFields.assessmentsMandatoryFields);
    const assetCategoryType = useSelector((state) => state?.serviceType);
    const status = useSelector((state) => state?.workOrderStatus?.status);
    const getStepper = useSelector((state) => state?.checkParts);
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const viewmode = location.state?.viewmode;
    const assessments = basicDetails?.assessments || {};
    const setOutsourceDetails = basicDetails?.vendorField;
    const repairTrackerRows = basicDetails?.assessments?.repairTracker || [];
    const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
    const categoryType = assetCategoryType?.category;
    const categoryFieldName = assetCategoryType?.category === "Scheduled" ? "scheduled" : "unscheduled";
    const repairCategoryFieldName = assetCategoryType?.category === "Scheduled" ? "sch" : "usch";
    const setScheduledField = categoryType === "Scheduled" ? true : false;
    const withPartsRequired = getStepper;
    const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');
    const companyId = getcompanyId('companyId');
    

    const [outSourceDialog, setOutSourceDialog] = useState(false);
    const [gridAPI, setGridApi] = useState({});
    const [assessmentsdata, setAssessmentsData] = useState(assessments || {});
    const [rows, setRows] = useState(repairTrackerRows || []);
      const [deleteRows, setDeleteRows] = useState([]);
      const [isOnchange, setIsOnchange] = useState(false);
    const [errorDialog,setErrorDialog] = useState(false);
    const [errorDialogMssg,setErrorDialogMssg] = useState("");
    const [errorMessage, setErrorMessage] = useState({
        respondedBy: "",
        respondedStartDateandTime: "",
        respondedEndDateandTime: "",
        taskCode: "",
        repairType: "",
        repairTrackerRows:""

    });
    const [error, setError] = useState({
        respondedBy: false,
        respondedStartDateandTime: false,
        respondedEndDateandTime: false,
        taskCode: false,
        repairType: false,
        repairTrackerRows:false

    });

    const [dialogOpen, setDialogOpen] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [option, setOption] = useState({
        respondedBy: [],
        taskCode: [],
        vendor: []
    });
    const [scheduled, setScheduled] = useState(setScheduledField);
    const [loading,setLoading] = useState(false);
    const [pageName, setPageName] = useState("");
    const [editData, setEditData] = useState(null);

    
    const statusMapping = {
        "Open": 1,
        "In Progress": 3,
        "Completed": 4,
        "Closed": 5,
        "Cancelled": 6,
        "Verified": 8,
        "Not Done and Closed":7,
        "Completed-Outsource":9,
        "In Progress-Outsource":10
    };

    // Map the current status to the corresponding number
    const mappedStatus = statusMapping[status] || null; // If status doesn't exist, fallback to null or any default value
    const shouldEnableDeleteAndEdit = !viewmode && mappedStatus !== 5 && mappedStatus !== 6;

    const formatDate = (dateString) => {
        if (!dateString) {
            return '';
        };
        const formattedDate = format(new Date(dateString), 'dd/MM/yyyy HH:mm:ss'); // Format the date as 'dd/MM/yyyy HH:mm:ss'
        return formattedDate;
    };

    const columns_Field = [
        ...(setOutsourceDetails || !!(assessmentsdata?.repairType === "Outsource")
          ? [
            { field: 'vendor', headerName: 'Vendor', flex: 1, valueGetter: (params) => params?.data ? assessmentsdata?.vendor?.label || "" : "" },
            { field: 'technician', headerName: 'Vendor Technician', flex: 1 },
          ]
          : [
            {
              field: 'employeeName',
              headerName: 'Employee Name',
              flex: 1,
              minWidth: isSmallScreen ? 150 : 200,
              valueGetter: (params) => params?.data?.employeename ? params?.data.employeename?.employeename : '',
            }
          ]
        ),
        {
          field: 'flag',
          headerName: 'Flag',
          flex: 1,
          minWidth: isSmallScreen ? 80 : 120,
          valueGetter: (params) => params?.data?.flag ? params?.data.flag?.label : '',
        },
        {
          field: 'pic',
          headerName: 'Unit',
          flex: 1,
          minWidth: isSmallScreen ? 80 : 120,
          valueGetter: (params) => params?.data?.pic ? params?.data.pic?.label : '',
        },
        {
          field: 'activity',
          headerName: 'Activity',
          flex: 1,
          minWidth: isSmallScreen ? 80 : 120,
          valueGetter: (params) => params?.data?.activity ? params?.data.activity?.label : '',
        },
        {
          field: 'startDateandTime',
          headerName: 'Start Date/Time ',
          flex: 1,
          minWidth: isSmallScreen ? 80 : 120,
          valueGetter: (params) => formatDate(params?.data?.startDateandTime),
        },
        {
          field: 'endDateandTime',
          headerName: 'End Date/Time ',
          flex: 1,
          minWidth: isSmallScreen ? 80 : 120,
          valueGetter: (params) => formatDate(params?.data?.endDateandTime),
        },
        {
          field: 'repairDuration',
          headerName: 'Repair Duration',
          flex: 1,
          minWidth: isSmallScreen ? 80 : 120,
        },
        {
          field: 'remarks',
          headerName: 'Remarks',
          flex: 1,
          minWidth: isSmallScreen ? 80 : 120,
        }
      ];

    useEffect(() => {
        setRows(repairTrackerRows || []);

        if(repairTrackerRows?.length > 0){
            setError((prev) => ({
              ...prev,
              repairTrackerRows: false,
            }));
      
            setErrorMessage((prev)=>({
              ...prev,
              repairTrackerRows:""
            }))
          }

    }, [repairTrackerRows])


    const handleOnchange = (value, name) => {
        setAssessmentsData((previous) => {
            const updatedData = {
                ...previous,
                [name]: value,
            };

            if (name === "respondedBy") {
                if (value?.id) {
                    updatedData.respondedBy = { ...value, label: value?.employeename };
                    updatedData.designation = value?.designation;
                } else {
                    updatedData.respondedBy = "";
                    updatedData.designation = "";
                }
            };

            if (name === "taskCode") {

                if (value?.id) {
                    updatedData.taskCode = { ...value, label: value?.taskCode }
                    updatedData.taskDescription = value?.taskDesc;
                } else {
                    updatedData.taskCode = "";
                    updatedData.taskDescription = "";
                }
            };

            if (name === "partsRequired") {
                if (value?.label === 'No') {
                    dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
                } else {
                    dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
                }
            };

            if (name === 'repairType') {        
                    setIsOnchange(true);
                    dispatch(updateOutsourceDetails("SET_VENDORFIELD", value === 'Outsource' ? true : false));
                    if (value === 'Outsource') {
                      updatedData.vendor = { id: "", label: "" };
                      // updatedData.respondedBy = { id: "", label: "" };
                      // updatedData.designation = "";
            
                      setDeleteRows(rows || []);
                      // Dispatch action to clear repair tracker
                      dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));
            
                      setError((prev) => ({
                        ...prev,
                        repairTrackerRows: false,
                        // respondedBy: false
                      }));
            
                      setErrorMessage((prev) => ({
                        ...prev,
                        repairTrackerRows: "",
                        // respondedBy: ""
                      }))
            
                    } else 
                      setDeleteRows(rows || []);
                      // Dispatch action to clear repair tracker
                      dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));
                      updatedData.vendor = { id: "", label: "" };
            
                      setError((prev) => ({
                        ...prev,
                        repairTrackerRows: false
                      }));
            
                      setErrorMessage((prev) => ({
                        ...prev,
                        repairTrackerRows: ""
                      }))
                    
                  };

                  if (name === "vendor") {
                    setAssessmentsData((previousValue) => {
                    const currentVendor = previousValue.vendor?.id || ""; // Get the current vendor ID
                    const newVendor = value?.id || ""; // Get the new vendor ID
            
                    // Check if the vendor has changed
                    if (currentVendor !== newVendor && !isOnchange) {
                        setDeleteRows(rows || []);
                        // Dispatch action to clear repair tracker
                        dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));
            
                        return {
                        ...previousValue,
                        vendor: value || { id: "", label: "" }, // Update the vendor field
                        };
                    } else {
                        return previousValue; // Return unchanged state if the vendor hasn't changed
                    }
                    });
                };

            return updatedData;
        });

        const workOrderDateAndTime = basicDetails?.workorderDateandTime;
        if (name === 'respondedStartDateandTime' && value && workOrderDateAndTime) {
            const workOrderDate = new Date(workOrderDateAndTime);
            const selectedDate = new Date(value);
            const endDate = new Date(assessmentsdata?.respondedEndDateandTime);

            if (selectedDate < workOrderDate) {
                setError((prev) => ({
                    ...prev,
                    respondedStartDateandTime: true
                }));

                setErrorMessage((prev) => ({
                    ...prev,
                    respondedStartDateandTime: "Responded Start date and time should be greater than the work order date and time."
                }));
                return;
            } else {
                setError((prev) => ({
                    ...prev,
                    respondedStartDateandTime: false
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    respondedStartDateandTime: ""
                }));

            }

            // Check if the end date is before the start date
            if (endDate && selectedDate > endDate) {
                setError(prevErrors => ({
                    ...prevErrors,
                    respondedEndDateandTime: true,
                }));
                setErrorMessage(prevErrorMessages => ({
                    ...prevErrorMessages,
                    respondedEndDateandTime: "Responded End date and time should be greater than the Responded Start date and time.",
                }));
            } else if (error.respondedEndDateandTime) {
                setError(prevErrors => ({
                    ...prevErrors,
                    respondedEndDateandTime: false,
                }));
                setErrorMessage(prevErrorMessages => ({
                    ...prevErrorMessages,
                    respondedEndDateandTime: "",
                }));
            };
        };

        if (name === 'respondedEndDateandTime' && value) {
            const respondStartdateandTime = new Date(assessmentsdata?.respondedStartDateandTime);
            const selectedDate = new Date(value);
            if (selectedDate < respondStartdateandTime) {
                setError({
                    ...error,
                    respondedEndDateandTime: true,
                });
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    respondedEndDateandTime: "Responded End date and time should be greater than the Response Start date and time.",
                }));
                return;
            } else {
                setError((prevErrors) => ({
                    ...prevErrors,
                    respondedEndDateandTime: false,
                }));
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    respondedEndDateandTime: "",
                }));
            };
        };

        setError((prev) => {
            const updatedError = {
                ...prev,
                [name]: false
            };
            return updatedError;
        });

        setErrorMessage((prev) => ({
            ...prev,
            [name]: ''
        }));
    };

    const handleRepairTypeChange = (event) => {
        handleOnchange(event.target.value, "repairType");
    };

    const memoizedDetails = useMemo(() => ({
        respondedBy: assessmentsdata?.respondedBy || '',
        respondedStartDateandTime: assessmentsdata?.respondedStartDateandTime || '',
        taskCode: assessmentsdata?.taskCode || '',
        repairType: assessmentsdata?.repairType || '',
        vendor:assessmentsdata?.vendor || ""
    }), [
        assessmentsdata?.respondedBy,
        assessmentsdata?.respondedStartDateandTime,
        assessmentsdata?.taskCode,
        assessmentsdata?.repairType,
        assessmentsdata?.vendor
    ]);

    //function to check the mandatory field are filled or not(responsible for green ticks on left side)
    const checkMandatoryValueFilled = useCallback(debounce((
        respondedBy,
        respondedStartDateandTime,
        taskCode,
        repairType,
        vendor
    ) => {
        const updateStatus = (type, value, name, isVisible, errorState) => ({
            type,
            valueFilled: !errorState && !!value,
            name,
            isVisible
        });

        const updateRespondedBy = updateStatus("Responded By", respondedBy, 'respondedBy', !(scheduled && setOutsourceDetails), error.respondedBy);
        const updateRespondedStartDateandTime = updateStatus("Response Start Date & Time", respondedStartDateandTime, 'respondedStartDateandTime', !scheduled, error.respondedStartDateandTime);
        const updateTaskCode = updateStatus("Task Code", taskCode, 'taskCode', true, error.taskCode);
        const updaterepairType = updateStatus("Repair Type", repairType, 'repairType', true, error.repairType);
        const updateVendor = updateStatus("Vendor", vendor, 'vendor', setOutsourceDetails, error.vendor);

        let arrayAfterUpdating = [
            updateTaskCode,
            updaterepairType,
        ];

        if(!(scheduled && setOutsourceDetails)){
            arrayAfterUpdating.push(updateRespondedBy)
        };

        if(setOutsourceDetails){
            arrayAfterUpdating?.push(updateVendor)
        };

        if(!scheduled){
            arrayAfterUpdating.push(updateRespondedStartDateandTime)
        };

        if (arrayAfterUpdating !== undefined && arrayAfterUpdating.every(item => item !== undefined)) {
            dispatch({ type: "UPDATE_WORK_ORDER_ASSESMENTS_MANDATORY_FIELDS", payload: arrayAfterUpdating })
        }
    }), [dispatch, setOutsourceDetails, error]);

    useEffect(() => {
        const {
            respondedBy,
            respondedStartDateandTime,
            taskCode,
            repairType,
            vendor
        } = memoizedDetails;
        checkMandatoryValueFilled(
            respondedBy?.id,
            respondedStartDateandTime,
            taskCode?.id,
            repairType,
            vendor?.id
        );
    }, [
        memoizedDetails,
        checkMandatoryValueFilled
    ]);

    const handleValidationForRequiredFields = () => {
        let isValid = true;
        assessmentsMandatoryFields.map((item) => {
            if (item.valueFilled === false) {
                if (error[item.name]) {
                    isValid = false;
                } else {
                    setError((prev) => ({
                        ...prev,
                        [item.name]: true,
                    }));
                    setErrorMessage((prev) => ({
                        ...prev,
                        [item.name]: `${item.type} is required `,
                    }));
                }

                isValid = false;
            }
        });
        if (repairTrackerRows <= 0) {
            setError((prev) => ({
              ...prev,
              repairTrackerRows: true,
            }));
            setErrorMessage((prev) => ({
              ...prev,
              repairTrackerRows: "Please add at least one repair tracker row",
            }));
            isValid = false;
          }
        return isValid;
    };


    useEffect(() => {
        setAssessmentsData((previousValue) => {
            return {
            ...previousValue,
            vendor: assessments?.vendor || ''
            }
        });

        setScheduled(setScheduledField);
    }, [basicDetails?.editmode])


    const fetchOptions = async () => {
        const respondedBy = await ScmRepositry.fetchEmployeeDetails();
        setOption((previous) => ({
            ...previous,
            respondedBy: respondedBy?.map((item, index) => ({
                key: `option${index}`,
                label: `${item?.employeecode || ""} - ${item?.employeename || ""}` || "",
                employeename: item?.employeename || "",
                designation: item?.designation || "",
                empservice: item?.empservice || "",
                id: item?.id
            }))
        }));

        const taskCode = await ScmRepositry.fetchTaskCode(serviceType, basicDetails?.referenceWorkOrderNo?.workGroupId);

        setOption((previous) => ({
            ...previous,
            taskCode: taskCode?.map((item, index) => ({
                key: `option${index}`,
                label: `${item?.taskcode || ""} - ${item?.taskdesc || ""}` || "",
                taskCode: item?.taskcode || "",
                taskDesc: item?.taskdesc || "",
                id: item?.id
            }))
        }));

        const vendorOptions = await ScmRepositry.fetchVendorDetails();
        
        setOption((previous) => ({
            ...previous,
            vendor: vendorOptions?.map((details, index) => ({
                key: `option${index}`,
                label: details?.vendorname || "",
                vendorName: details?.vendorname || "",
                vendorcode: details?.vendorcode || "",
                vendoremail: details?.vendoremail || "",
                serviceCode: details?.servicecode || "",
                id: details?.id
            }))
        }))
    };

    const handleOutsourceSubmit = () => {
        setOutSourceDialog(false);
    };

    const handleDelete = (row) => {
        setDeleteDialog(true);
        setDeleteId(row)
    };


    const handleCloseCancelDialog = () => {
        setDeleteDialog(false);
    };

    const handleConfirmDelete = async () => {
        try {
            await ScmRepositry.deleteRepairTracker(serviceType, deleteId?.id);

            let updatedRows = [];

            if (deleteId?.id) {
                updatedRows = rows?.filter((row) => row?.id !== deleteId?.id);
                setRows(updatedRows);
                dispatch({ type: 'DELETE_REPAIR_TRACKER', payload: { id: deleteId?.id } });
                setDeleteDialog(false);
            } else if (deleteId?.dummy_id) {
                updatedRows = rows?.filter((row) => row?.dummy_id !== deleteId?.dummy_id);
                setRows(updatedRows);
                dispatch({ type: 'DELETE_REPAIR_TRACKER', payload: { dummy_id: deleteId?.dummy_id } });
                setDeleteDialog(false);
            };

        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async (event) => {
        setLoading(true);
        event.preventDefault();
        const isValid = handleValidationForRequiredFields();

        if (isValid) {

            const employeeName = await ScmRepositry.fetchEmployeeDetails();
            const lovOptions = await ScmRepositry.lovOptions();
            const mapEmpCode = (id) => {
                const empCode = employeeName?.find(empc => empc.id === id);
                return empCode ? empCode.employeecode : '';
            };

            const mapEmpName = (id) => {
                const empCode = employeeName?.find(empN => empN.id === id);
                return empCode ? empCode.employeename : '';
            };

            const mapFlagDesc = (id) => {
                const flagDesc = lovOptions?.femuschworepairflags?.find(desc => desc?.id === id);
                return flagDesc ? flagDesc?.repairflag : '';
            };

            const mapPicDesc = (id) => {
                const picDesc = lovOptions?.femuschworepairpics?.find(desc => desc?.id === id);
                return picDesc ? picDesc?.repairpic : '';
            };

            const mapActivityDesc = (id) => {
                const activityDesc = lovOptions?.femuschworepairactivities?.find(desc => desc?.id === id);
                return activityDesc ? activityDesc?.repairactivity : '';
            };

            if (basicDetails?.assessments?.id) {
                const updatePayload = {
                    respondedbyid: assessmentsdata?.respondedBy?.id || "",
                    responsestartdate: assessmentsdata?.respondedStartDateandTime || "",
                    responseenddate: assessmentsdata?.respondedEndDateandTime || "",
                    respondfinding: assessmentsdata?.respondedFinding || "",
                    ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
                    isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
                    vendorid: assessmentsdata?.vendor?.id || "",
                    respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
                    [`${serviceType}schcorrectivemaintenanceheaderId`]: basicDetails?.id || "",
                    [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
                    [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
                    id: assessments?.id || ""
                };

                const updateRepairDetailsPayload = rows?.map((row) => ({
                    employeeid: row?.employeename?.id || "",
                    repairstartdate: row?.startDateandTime || "",
                    repairenddate: row?.endDateandTime || "",
                    repairduration: row?.repairDuration || "",
                    preparationhours: row?.preparationHours || "",
                    verificationhours: row?.verificationHours || "",
                    Vendortechnician: row?.technician || "",
                    remarks: row?.remarks || "",
                    [`${serviceType}schcorrectiveworkorderheaderId`]: basicDetails?.id || "",
                    [`${serviceType}schcorrectiveassessmentheaderId`]: assessments?.id || "",
                    [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
                    [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
                    [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
                    id: row?.id || "",
                }));

                const assesmentsId = assessments?.id || "";
                dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));
                const updateAssessmentDetails = await ScmRepositry.updateAssessmentsDetails(serviceType, updatePayload, categoryType,);

                if (updateRepairDetailsPayload?.length > 0) {
                    const saveRepairTracker = await ScmRepositry.updateRepairTracker(serviceType, updateRepairDetailsPayload, assesmentsId);

                    saveRepairTracker?.forEach((row) => {
                        const transformedObject = {
                            employeename: {
                                employeeCode: mapEmpCode(row?.employeeid || ""),
                                employeename: mapEmpName(row?.employeeid || ""),
                                id: row?.employeeid || "",
                            },
                            flag: {
                                id: row?.[`${serviceType}uschworepairflagId`] || "",
                                label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
                            },
                            pic: {
                                id: row?.[`${serviceType}uschworepairpicId`] || "",
                                label: mapPicDesc(row?.[`${serviceType}uschworepairpicId`] || "")
                            },
                            activity: {
                                id: row?.[`${serviceType}uschworepairactivityId`] || "",
                                label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
                            },
                            technician: row?.technician || row?.vendortechnician || "",
                            startDateandTime: row?.repairstartdate || "",
                            endDateandTime: row?.repairenddate || "",
                            repairDuration: row?.repairduration || "",
                            preparationHours: row?.preparationhours || "",
                            verificationHours: row?.verificationhours || "",
                            remarks: row?.remarks || "",
                            id: row?.id || "",
                        };
                        dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", transformedObject));
                    });
                };
                
                if(updateAssessmentDetails?.id){
                    dispatch(assessmentsDetails("CREATE_ASSESMENTS", { ...assessmentsdata, id: updateAssessmentDetails?.id || "" }));
                    setPage("Attachments")
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                } else if (updateAssessmentDetails?.response?.data?.status >= 405){
                    setErrorDialog(true);
                    setErrorDialogMssg("An unexpected error occurred while processing your request.")
                  }
            }

            else {
                const APIPayload = {
                    respondedbyid: assessmentsdata?.respondedBy?.id || "",
                    responsestartdate: assessmentsdata?.respondedStartDateandTime || "",
                    responseenddate: assessmentsdata?.respondedEndDateandTime || "",
                    respondfinding: assessmentsdata?.respondedFinding || "",
                    ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
                    isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
                    vendorid: assessmentsdata?.vendor?.id || "",
                    respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
                    [`${serviceType}schcorrectivemaintenanceheaderId`]: basicDetails?.id || "",
                    [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
                    [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
                };
                

                const saveAssessments = await ScmRepositry.addAssessmentsDetails(serviceType, APIPayload);
                const repairDetailsPayload = rows?.map((row) => ({
                    employeeid: row?.employeename?.id || "",
                    repairstartdate: row?.startDateandTime || "",
                    repairenddate: row?.endDateandTime || "",
                    repairduration: row?.repairDuration || "",
                    preparationhours: row?.preparationHours || "",
                    verificationhours: row?.verificationHours || "",
                    remarks: row?.remarks || "",
                    Vendortechnician: row?.technician || "",
                    [`${serviceType}schcorrectiveworkorderheaderId`]: basicDetails?.id || "",
                    [`${serviceType}schcorrectiveassessmentheaderId`]: saveAssessments?.id || "",
                    [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
                    [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
                    [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
                    id: row?.id || "",
                }));

                dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []))

                const saveRepairTracker = await ScmRepositry.addRepairTracker(serviceType, repairDetailsPayload);
                const rtLength = saveRepairTracker?.length;
                const getRepairTrackerId = saveRepairTracker?.[rtLength - 1];

                saveRepairTracker?.forEach((row) => {
                    const transformedObject = {
                        employeename: {
                            employeeCode: mapEmpCode(row?.employeeid || ""),
                            employeename: mapEmpName(row?.employeeid || ""),
                            id: row?.employeeid || "",
                        },
                        flag: {
                            id: row?.[`${serviceType}uschworepairflagId`] || "",
                            label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
                        },
                        pic: {
                            id: row?.[`${serviceType}uschworepairpicId`] || "",
                            label: mapPicDesc(row?.[`${serviceType}uschworepairpicId`] || "")
                        },
                        activity: {
                            id: row?.[`${serviceType}uschworepairactivityId`] || "",
                            label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
                        },
                        technician: row?.technician || row?.vendortechnician || "",
                        startDateandTime: row?.repairstartdate || "",
                        endDateandTime: row?.repairenddate || "",
                        repairDuration: row?.repairduration || "",
                        preparationHours: row?.preparationhours || "",
                        verificationHours: row?.verificationhours || "",
                        remarks: row?.remarks || "",
                        id: row?.id || "",
                    };
                    dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", transformedObject));
                });
                if(saveAssessments?.id){
                    dispatch(assessmentsDetails("CREATE_ASSESMENTS", { ...assessmentsdata, id: saveAssessments?.id || "", repairtrackerId: getRepairTrackerId?.id || "" }));
                    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: (assessmentsdata?.repairType === "Inhouse" || assessments?.repairType === "Inhouse") ? statusList?.inProgress?.label : statusList?.inProgressOutsource?.label, percentage: processingPercentageValue?.assessmentTab }))
                    setPage("Attachments")
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                } else if (saveAssessments?.response?.data?.status >= 405){
                    setErrorDialog(true);
                    setErrorDialogMssg("An unexpected error occurred while processing your request.")
                }
            };

        }
        else if (viewmode == true || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6) {
          setPage("Attachments")
            dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        };
        setLoading(false);

    };


    const handledialogforOutSource = async () => {
        setLoading(true);
        const isValid = handleValidationForRequiredFields();
        if (isValid) {

            const employeeName = await ScmRepositry.fetchEmployeeDetails();
            const lovOptions = await ScmRepositry.lovOptions();
            const mapEmpCode = (id) => {
                const empCode = employeeName?.find(empc => empc.id === id);
                return empCode ? empCode.employeecode : '';
            };

            const mapEmpName = (id) => {
                const empCode = employeeName?.find(empN => empN.id === id);
                return empCode ? empCode.employeename : '';
            };

            const mapFlagDesc = (id) => {
                const flagDesc = lovOptions?.femuschworepairflags?.find(desc => desc?.id === id);
                return flagDesc ? flagDesc?.repairflag : '';
            };

            const mapPicDesc = (id) => {
                const picDesc = lovOptions?.femuschworepairpics?.find(desc => desc?.id === id);
                return picDesc ? picDesc?.repairpic : '';
            };

            const mapActivityDesc = (id) => {
                const activityDesc = lovOptions?.femuschworepairactivities?.find(desc => desc?.id === id);
                return activityDesc ? activityDesc?.repairactivity : '';
            };

            if (basicDetails?.assessments?.id) {
                const updatePayload = {
                    respondedbyid: assessmentsdata?.respondedBy?.id || "",
                    responsestartdate: assessmentsdata?.respondedStartDateandTime || "",
                    responseenddate: assessmentsdata?.respondedEndDateandTime || "",
                    respondfinding: assessmentsdata?.respondedFinding || "",
                    ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
                    isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
                    vendorid: assessmentsdata?.vendor?.id || "",
                    respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
                    [`${serviceType}schcorrectivemaintenanceheaderId`]: basicDetails?.id || "",
                    [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
                    [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
                    id: assessments?.id || "",
                };

                const updateRepairDetailsPayload = rows?.map((row) => ({
                    employeeid: row?.employeename?.id || "",
                    repairstartdate: row?.startDateandTime || "",
                    repairenddate: row?.endDateandTime || "",
                    repairduration: row?.repairDuration || "",
                    preparationhours: row?.preparationHours || "",
                    verificationhours: row?.verificationHours || "",
                    remarks: row?.remarks || "",
                    Vendortechnician: row?.technician || "",
                    [`${serviceType}schcorrectiveworkorderheaderId`]: basicDetails?.id || "",
                    [`${serviceType}schcorrectiveassessmentheaderId`]: assessments?.id || "",
                    [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
                    [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
                    [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
                    id: row?.id || "",
                }));

                const assesmentsId = basicDetails?.assessments?.id || "";
                dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));
                const updateAssessmentDetails = await ScmRepositry.updateAssessmentsDetails(serviceType, updatePayload, categoryType,);

                if (updateRepairDetailsPayload?.length > 0) {
                    const saveRepairTracker = await ScmRepositry.updateRepairTracker(serviceType, updateRepairDetailsPayload, assesmentsId);
                    saveRepairTracker?.forEach((row) => {
                        const transformedObject = {
                            employeename: {
                                employeeCode: mapEmpCode(row?.employeeid || ""),
                                employeename: mapEmpName(row?.employeeid || ""),
                                id: row?.employeeid || "",
                            },
                            flag: {
                                id: row?.[`${serviceType}uschworepairflagId`] || "",
                                label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
                            },
                            pic: {
                                id: row?.[`${serviceType}uschworepairpicId`] || "",
                                label: mapPicDesc(row?.[`${serviceType}uschworepairpicId`] || "")
                            },
                            activity: {
                                id: row?.[`${serviceType}uschworepairactivityId`] || "",
                                label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
                            },
                            technician: row?.technician || row?.vendortechnician || "",
                            startDateandTime: row?.repairstartdate || "",
                            endDateandTime: row?.repairenddate || "",
                            repairDuration: row?.repairduration || "",
                            preparationHours: row?.preparationhours || "",
                            verificationHours: row?.verificationhours || "",
                            remarks: row?.remarks || "",
                            id: row?.id || "",
                        };
                        dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", transformedObject));
                    });
                }

                // const service = assetCategoryType?.assetType === "fem" ? "FEMS" : "BEMS";
                // const graphUrl = `${window.location.hostname}:${window.location.port}`;
                // const emailPayload = {
                // vendorId: assessmentsdata?.vendor?.id || "",
                // workorderId: basicDetails?.id || "",
                // applicationSecurityKey: "ENC45TY-09",
                // url: graphUrl,
                // serviceId: "",
                // service: service,
                // statusId: statusList?.inProgressOutsource?.id,
                // category: categoryFieldName
                // };
                // await ScmRepositry.sendVendorEmail(serviceType, emailPayload);

                if (updateAssessmentDetails?.id) {
                    dispatch(assessmentsDetails("CREATE_ASSESMENTS", { ...assessmentsdata, id: updateAssessmentDetails?.id || "" }));
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                } else if (updateAssessmentDetails?.response?.data?.status >= 405){
                    setErrorDialog(true);
                    setErrorDialogMssg("An unexpected error occurred while processing your request.")
                }
            }

            else {
                const APIPayload = {
                    respondedbyid: assessmentsdata?.respondedBy?.id || "",
                    respondedByName: assessmentsdata?.respondedBy?.employeecode || "",
                    responsestartdate: assessmentsdata?.respondedStartDateandTime || "",
                    responseenddate: assessmentsdata?.respondedEndDateandTime || "",
                    respondfinding: assessmentsdata?.respondedFinding || "",
                    ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
                    isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
                    vendorid: assessmentsdata?.vendor?.id || "",
                    respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
                    [`${serviceType}schcorrectivemaintenanceheaderId`]: basicDetails?.id || "",
                    [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
                    [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
                };

                const saveAssessments = await ScmRepositry.addAssessmentsDetails(serviceType, APIPayload, categoryType);
                const repairDetailsPayload = rows?.map((row) => ({
                    employeeid: row?.employeename?.id || "",
                    repairstartdate: row?.startDateandTime || "",
                    repairenddate: row?.endDateandTime || "",
                    repairduration: row?.repairDuration || "",
                    preparationhours: row?.preparationHours || "",
                    verificationhours: row?.verificationHours || "",
                    remarks: row?.remarks || "",
                    Vendortechnician: row?.technician || "",
                    [`${serviceType}schcorrectivemaintenanceheaderId`]: basicDetails?.id || "",
                    [`${serviceType}schcorrectiveassessmentheaderId`]: saveAssessments?.id || "",
                    [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
                    [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
                    [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
                    id: row?.id || "",
                }));

                dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []))

                const saveRepairTracker = await ScmRepositry.addRepairTracker(serviceType, repairDetailsPayload);
                const rtLength = saveRepairTracker?.length;
                const getRepairTrackerId = saveRepairTracker?.[rtLength - 1];

                saveRepairTracker?.forEach((row) => {
                    const transformedObject = {
                        employeename: {
                            employeeCode: mapEmpCode(row?.employeeid || ""),
                            employeename: mapEmpName(row?.employeeid || ""),
                            id: row?.employeeid || "",
                        },
                        flag: {
                            id: row?.[`${serviceType}uschworepairflagId`] || "",
                            label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
                        },
                        pic: {
                            id: row?.[`${serviceType}uschworepairpicId`] || "",
                            label: mapPicDesc(row?.[`${serviceType}uschworepairpicId`] || "")
                        },
                        activity: {
                            id: row?.[`${serviceType}uschworepairactivityId`] || "",
                            label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
                        },
                        technician: row?.technician || row?.vendortechnician || "",
                        startDateandTime: row?.repairstartdate || "",
                        endDateandTime: row?.repairenddate || "",
                        repairDuration: row?.repairduration || "",
                        preparationHours: row?.preparationhours || "",
                        verificationHours: row?.verificationhours || "",
                        remarks: row?.remarks || "",
                        id: row?.id || "",
                    };
                    dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", transformedObject));
                });
                // const service = assetCategoryType?.assetType === "fem" ? "FEMS" : "BEMS";
                // const graphUrl = `${window.location.hostname}:${window.location.port}`;
                // const emailPayload = {
                // vendorId: assessmentsdata?.vendor?.id || "",
                // workorderId: basicDetails?.id || "",
                // applicationSecurityKey: "ENC45TY-09",
                // url: graphUrl,
                // statusId: statusList?.inProgressOutsource?.id,
                // serviceId: "",
                // service: service,
                // category: categoryFieldName
                // };
                // await ScmRepositry.sendVendorEmail(serviceType, emailPayload);
                // dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "In Progress", percentage: 32 }))

                if (saveAssessments?.id) {
                    dispatch(assessmentsDetails("CREATE_ASSESMENTS", { ...assessmentsdata, id: saveAssessments?.id || "", repairtrackerId: getRepairTrackerId?.id || "" }));
                    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: statusList?.inProgressOutsource?.label, percentage: processingPercentageValue?.assessmentTab }))
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED")); // Access the checked state of the switch using event.target.checked and set false switch action  
                  } else if (saveAssessments?.response?.data?.status >= 405){
                    setErrorDialog(true);
                    setErrorDialogMssg("An unexpected error occurred while processing your request.")
                  }
            };
        }

        setLoading(false);
        if (isValid) {
            setOutSourceDialog(true);
        };

    };

    useEffect(() => {
        const fetchOptionsData = async () =>{
            setLoading(true);
            await fetchOptions();
            setLoading(false);
        };
        
        if (!(assessments?.id)) {
            setAssessmentsData((prev) => ({
                ...prev,
                respondedStartDateandTime: prev?.respondedStartDateandTime || basicDetails?.workorderDateandTime || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                respondedEndDateandTime: prev?.respondedEndDateandTime || "",
            }));    
        };

        fetchOptionsData();

        if (!scheduled && !assessments?.id) {
            const getRepairType =
              basicDetails?.repairType ||
              basicDetails?.assessments?.repairType ||
              "";
            setAssessmentsData((prev) => ({
              ...prev,
              repairType: getRepairType,
            }));
          }
          

    }, []);

    const handleConfirm = () => {
        handleCloseDialog();
    };

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setEditData(null);
    };

    const handleEdit = (row) => {
        setEditData(row);
        setDialogOpen(true);
    };

    const handleCloseErrRequestDialog = () => {
        setErrorDialog(false);
        setErrorDialogMssg("");
      };
    
      const handleConfirmErrRequestDialog = (e) => {
        e.preventDefault();
        setErrorDialog(false);
        setErrorDialogMssg("")
      };

    return (
        <>
            <PageLoader open={loading} />
            <ComponentHeader
                mainHeader={findHeaderContent?.mainHeader}
                subHeader={findHeaderContent?.subHeader}
                secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
                requiredButton={viewmode ? false : findHeaderContent?.requiredButton}
            />
            <Box >
                <form style={{ position: "relative" }} onSubmit={handleSubmit} noValidate>
                    <Stack direction={'row'} alignItems={'center'} gap={1.5}>
                        <Typography m={0} variant='title2' color={'text.primary'} fontWeight={600}>{basicDetails?.schcorrectiveno || ""}</Typography>
                    </Stack>
                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Typography variant='title2'> Responded Details </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomTextFieldWithSearch
                                    label="Assignee"
                                    id="respondedDetails"
                                    name="respondedBy"
                                    onChange={handleOnchange}
                                    options={option?.respondedBy || []}
                                    value={assessmentsdata?.respondedBy || ""}
                                    error={error?.respondedBy}
                                    errorMessage={errorMessage?.respondedBy}
                                    isMandatoryField={!(scheduled && setOutsourceDetails) ? true : false}
                                    disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || assessments?.id}
                                    autoFocus
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomTextField
                                    label="Designation"
                                    id="designation"
                                    name="designation"
                                    onChange={handleOnchange}
                                    value={assessmentsdata?.designation || ""}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={6} md={4} sm={6}>
                                <CustomDateTimePicker
                                    label="Responded Start Date and Time"
                                    onDateChange={(e) => handleOnchange(e, "respondedStartDateandTime")}
                                    value={assessmentsdata?.respondedStartDateandTime}
                                    error={error?.respondedStartDateandTime}
                                    helperText={errorMessage?.respondedStartDateandTime}
                                    disableFutureDate={false}
                                    isMandatoryField={true}
                                    displayDefaultValue={false}
                                   // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}
                                   disabled={true}
                                />
                            </Grid>
                            <Grid item xs={6} md={4} sm={6}>
                                <CustomDateTimePicker
                                    label="Responded End Date and Time"
                                    value={assessmentsdata?.respondedEndDateandTime || ""}
                                    onDateChange={(e) => handleOnchange(e, "respondedEndDateandTime")}
                                    error={error?.respondedEndDateandTime}
                                    helperText={errorMessage?.respondedEndDateandTime}
                                    disableFutureDate={false}
                                    isMandatoryField={false}
                                    displayDefaultValue={false}
                                    disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomTextFieldWithSearch
                                    label={"Task Code"}
                                    id={"taskCode"}
                                    name={"taskCode"}
                                    onChange={handleOnchange}
                                    value={assessmentsdata?.taskCode || ""}
                                    options={option?.taskCode || []}
                                    error={error?.taskCode}
                                    errorMessage={errorMessage?.taskCode}
                                    isMandatoryField={true}
                                    disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}

                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomTextField
                                    label="Task Description"
                                    id="taskdescription"
                                    name="taskDescription"
                                    onChange={handleOnchange}
                                    value={assessmentsdata?.taskDescription || ""}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6}>
                                <FormControl component="fieldset" error={error.repairType}>
                                    <Typography variant="labelSm" color={"text.primary"} component={"label"}>
                                        Repair Type
                                        <Typography component={"span"} color={"error"}>
                                            *
                                        </Typography>
                                    </Typography>
                                    <RadioGroup
                                        row
                                        name="repairType"
                                        onChange={handleRepairTypeChange}
                                        value={assessmentsdata?.repairType || ""}
                                        aria-required={true}
                                        defaultValue="Inhouse"
                                    >
                                        <FormControlLabel value="Inhouse" control={<Radio />} label="Inhouse" disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || scheduled} />
                                        <FormControlLabel value="Outsource" control={<Radio />} label="Outsource" disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || scheduled} />
                                    </RadioGroup>
                                    <FormHelperText>{errorMessage.repairType}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomSelectInput
                                    label={"Parts Required"}
                                    name="partsRequired"
                                    value={assessmentsdata?.partsRequired || ""}
                                    onChange={handleOnchange}
                                    options={[{ id: 1, label: "Yes" }, { id: 2, label: "No" }]}
                                    disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}

                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomSelectInput
                                    label={"Asset Taken Location"}
                                    name="assetTakenLocation"
                                    value={assessmentsdata?.assetTakenLocation || ""}
                                    onChange={handleOnchange}
                                    options={[{ id: 1, label: "Yes" }, { id: 2, label: "No" }]}
                                    disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomTextArea
                                    label="Respond Finding"
                                    id="respondedFinding"
                                    onChange={(e) => handleOnchange(e, "respondedFinding")}
                                    value={assessmentsdata?.respondedFinding || ""}
                                    disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}
                                    maxLength={100}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    {setOutsourceDetails && (
                        <>
                            <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                                <Typography variant='title2' >Outsource Details</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4} sm={6}>
                                        <CustomTextFieldWithSearch
                                            label={"Vendor"}
                                            id={"vendor"}
                                            name={"vendor"}
                                            onChange={handleOnchange}
                                            value={assessmentsdata?.vendor || ""}
                                            options={option?.vendor || []}
                                            disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}
                                            isMandatoryField={setOutsourceDetails ? true : false}
                                            error={error?.vendor}
                                            errorMessage={errorMessage?.vendor || ""}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4} sm={6}>
                                        <CustomTextField
                                            label="Outsource Respond remarks"
                                            name="outsourceRespondRemarks"
                                            value={assessmentsdata?.outsourceRespondRemarks || ""}
                                            onChange={handleOnchange}
                                            disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    )}

                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" mb={2}>
                            <Typography variant='title2'> Repair Tracker </Typography>
                            <Box sx={{ flexGrow: 1 }} />
                            {!viewmode && mappedStatus !== 5 && mappedStatus !== 6 && (
                                <AddRowButton onClick={handleOpenDialog} />
                            )}
                        </Stack>
                        {error?.repairTrackerRows && (
                            <Typography component={"span"} color={"error"}>
                                {errorMessage?.repairTrackerRows}*
                            </Typography>
                        )}
                        <CustomAgGrid
                            refSet={gridAPI}
                            rows={rows}
                            columns={columns_Field}
                            setGridApi={setGridApi}
                            handleDelete={shouldEnableDeleteAndEdit ? (row) => handleDelete(row) : null}
                            handleEdit={shouldEnableDeleteAndEdit ? (row) => handleEdit(row) : null}
                        />

                    </Box>

                    <Box>
                        <ScmBottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} outsourseSubmitBtn={setOutsourceDetails} enableAuthorizeButton={false} outsourceHandleConfirm={handledialogforOutSource} disableSubmitBtn={setOutsourceDetails && mappedStatus === 4 || setOutsourceDetails && mappedStatus === 5 || setOutsourceDetails && mappedStatus === 6 ? true : false} />
                    </Box>
                </form>
            </Box>

            <AddRowDialogue
                open={dialogOpen}
                onClose={handleCloseDialog}
                onConfirm={handleConfirm}
                editMode={editData}
                rows={rows}
                setRows={setRows}
                vendorName={assessmentsdata?.vendor?.label || ""}
                />
            <CustomAlert
                open={outSourceDialog}
                onClose={handleCloseDialog}
                onConfirm={handleOutsourceSubmit}
                content={`${basicDetails?.schcorrectiveno || ""} have been successfully shared to Vendor`}
                confirmBtn='OK'
            />

            <CustomAlert
                open={errorDialog}
                onClose={handleCloseErrRequestDialog}
                onConfirm={handleConfirmErrRequestDialog}
                content={errorDialogMssg}
                confirmBtn='OK'
            />

            <CustomDialog
                open={deleteDialog}
                onClose={handleCloseCancelDialog}
                onConfirm={handleConfirmDelete}
                content="Are you sure you want to cancel?"
                cancelBtn="No"
                confirmBtn="Yes"
            />

        </>
    );
};

export default ScmAssessments
